const H5PDragQuestion = (attempt, parameters = {}) => {
	const answers = JSON.parse(attempt.h5p_response.answer) || [];
	const correctElementsMap = {};
	const elementsMap = {};

	try {
		parameters = typeof parameters === 'string' ? JSON.parse(parameters) : parameters;
	} catch (e) {
		console.error('Error parsing parameters:', e);
	}

	const areAnswersHidden = parameters.question.task.dropZones.every(dropzone => !dropzone.correctElements);

	if (parameters.question?.task?.elements) {
		parameters.question.task.elements.forEach((element, index) => {
			if (element.type?.params?.text) {
				const tempDiv = document.createElement('div');
				tempDiv.innerHTML = element.type.params.text;
				elementsMap[index] = tempDiv.textContent.trim();
			}
		});
	}

	if (parameters.question?.task?.dropZones) {
		parameters.question.task.dropZones.forEach((dropzone, index) => {
			const dropzoneName = dropzone.label ?
				dropzone.label.replace(/<\/?[^>]+(>|$)/g, "").trim() :
				`Dropzone ${index + 1}`;

			correctElementsMap[dropzoneName] = (dropzone.correctElements || [])
				.map(elementIndex => elementsMap[elementIndex])
				.filter(Boolean);
		});
	}

	const userAnswersByDropzone = {};
	answers.forEach(answer => {
		const [dropzone, draggedItem] = answer.answer.split(' -> ');
		if (!userAnswersByDropzone[dropzone]) {
			userAnswersByDropzone[dropzone] = [];
		}
		userAnswersByDropzone[dropzone].push({ item: draggedItem, correct: answer.correct });
	});

	const groupedAnswers = {};
	Object.entries(userAnswersByDropzone).forEach(([dropzone, userAnswers]) => {
		groupedAnswers[dropzone] = userAnswers.map(userAnswer => ({
			userAnswer: userAnswer.item,
			correct: userAnswer.correct
		}));
	});

	const generateTableRow = (dropzone, dropzoneIndex, dropzoneAnswers, correctAnswers) => {
		const isOdd = dropzoneIndex % 2 === 0;
		const rowClass = isOdd ? 'odd' : 'even';

		const totalRows = Math.max(dropzoneAnswers.length, correctAnswers.length);
		const rows = [];

		for (let i = 0; i < totalRows; i++) {
			const userAnswer = dropzoneAnswers[i] || null;
			const correctAnswer = correctAnswers[i] || '';

			const dropzoneCell = i === 0
				? `<td rowspan="${totalRows}" class="dropzone-cell">${dropzone}</td>`
				: '';

			const userAnswerCell = userAnswer
				? `<div class="box ${userAnswer.correct ? 'correct' : 'incorrect'}-container">
                    ${userAnswer.correct
					? '<i class="icon correct-icon pb-heroicons pb-heroicons-solid_check"></i>'
					: '<i class="icon incorrect-icon pb-heroicons pb-heroicons-solid_x-mark"></i>'}
                    ${userAnswer.userAnswer}
                   </div>`
				: '';

			rows.push(`
                <tr class="${rowClass}">
                    ${dropzoneCell}
                    ${!areAnswersHidden ? `<td>${correctAnswer}</td>` : ''}
                    <td>${userAnswerCell}</td>
                </tr>
            `);
		}

		return rows.join('');
	};

	return `
        <div class="h5p-drag-question">
            <table class="drag-question-table">
                <thead>
                    <tr>
                        <th>Dropzone</th>
                        ${!areAnswersHidden ? `<th>Correct Answers</th>` : ''}
                        <th>User's answers</th>
                    </tr>
                </thead>
                <tbody>
                    ${Object.keys(groupedAnswers)
						.map((dropzone, index) =>
							generateTableRow(dropzone, index, groupedAnswers[dropzone], correctElementsMap[dropzone] || [])
						)
						.join('')}
                </tbody>
            </table>
        </div>
    `;
};

export default H5PDragQuestion;
